import {Injectable, inject} from '@angular/core';
import {Router} from '@angular/router';
import {SiteOverviewPlanService} from 'src/app/services/site-overview-plan.service';
import {ProductType} from 'src/app/types/payment.type';
import {SiteSearchEntryDto} from '../../userway/sdk/UserWayApiClient';
import {SiteDetailsService} from './site-details.service';

export const UNAVAILABLE_FEATURE_ON_TRIAL_MESSAGE = 'This feature is not available during the trial.';

@Injectable({
  providedIn: 'root',
})
export class TrialSiteService {
  private router = inject(Router);
  private siteOverviewPlanService = inject(SiteOverviewPlanService);
  private siteDetailsService = inject(SiteDetailsService);

  upgrade(site: SiteSearchEntryDto, onComplete: () => void = () => {}) {
    this.siteOverviewPlanService.currentSite = site;
    this.siteOverviewPlanService.showPaymentForm(ProductType.Remediation).finally(() => {
      onComplete();
      this.siteDetailsService.showPayment.set(true);
      this.router
        .navigate([`widget/my-sites/p/1/site-details/overview`], {
          queryParams: {site: site.host},
          queryParamsHandling: 'merge',
        })
        .then(() => {});
    });
  }
}
